angular.module('omfm').directive('wkTypeGroup', WkTypeGroupDirective);

WkTypeGroupDirective.$inject = [];

function WkTypeGroupDirective() {
	return {
		restrict: "EA",
		replace:  true,
		scope:    {
			type:  '@',
			config: '=group'
		},
		templateUrl: "/app/omfm/templates/wkTypeGroup.html",
		link: function ($scope) {

		}
	}
}